import { Button, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { PractitionerEntityType } from "../../../../../lib/supabase/supabaseTypes";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { useState } from "react";
import { PractitionerFormDialog } from "@/dentlab/src/pages-via-dialog/practitioner/practitioner.dialog";
import { getProfileDisplayName } from "@/lib/utils/client-utils";

export const PractitionerList: React.FC = () => {
	const { clientId } = useCentralStore((state) => ({
		clientId: state.clientId,
	}));

	const [existingPractitionerFormOpen, setExistingPractitionerFormOpen] =
		useState(false);
	const [newPractitionerFormOpen, setNewPractitionerFormOpen] =
		useState(false);
	const [selectedPractitioner, setSelectedPractitioner] =
		useState<PractitionerEntityType | null>(null);

	const practitioners = useCentralStore((state) =>
		Object.values(state.practitionersLookup).filter(
			(prac) => prac.client_id === clientId
		)
	);

	return (
		<div>
			<div className="flex flex-col gap-2 mt-4 w-fit">
				{practitioners.map((practitioner: PractitionerEntityType) => (
					<div
						key={practitioner.id}
						className="flex items-center border p-4 rounded-md shadow w-full"
					>
						<div className="flex-grow">
							{getProfileDisplayName(practitioner)}
							{practitioner.email}
						</div>
						<IconButton
							aria-label="delete"
							size="medium"
							onClick={() => {
								setSelectedPractitioner(practitioner);
								setExistingPractitionerFormOpen(true);
							}}
						>
							<EditIcon />
						</IconButton>
					</div>
				))}
			</div>
			<Button onClick={() => setNewPractitionerFormOpen(true)}>
				Behandler hinzufügen
			</Button>
			{selectedPractitioner && (
				<PractitionerFormDialog
					open={existingPractitionerFormOpen}
					onClose={() => {
						setExistingPractitionerFormOpen(false);
						setSelectedPractitioner(null);
					}}
					practitioner={selectedPractitioner}
				/>
			)}
			{clientId && (
				<PractitionerFormDialog
					open={newPractitionerFormOpen}
					onClose={() => {
						setNewPractitionerFormOpen(false);
						setSelectedPractitioner(null);
					}}
					clientId={clientId}
				/>
			)}
		</div>
	);
};
